var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/no-unknown-property */
import React from "react";
import classNames from "classnames";
import IconContainer from "./IconContainer";
export const RightArrowMenu = (_a) => {
    var { className, size, title = "RightArrowMenu" } = _a, props = __rest(_a, ["className", "size", "title"]);
    return (React.createElement(IconContainer, Object.assign({}, props, { className: classNames("gerudo-icon-right-arrow-menu", className, size) }),
        React.createElement("svg", { width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("title", null, title),
            React.createElement("path", { d: "M4.66634 4.66634L1.33301 7.99967M1.33301 7.99967L4.66634 11.333M1.33301 7.99967H13.333M13.333 12.6663H8.66634M13.333 3.33301H8.66634", stroke: "currentColor", strokeWidth: "1.33333", strokeLinecap: "round", strokeLinejoin: "round", transform: "scale (-1, 1)", "transform-origin": "center" }))));
};
export default RightArrowMenu;
//# sourceMappingURL=RightArrowMenu.js.map